/** Minimal shape needed to describe a product for disambiguation. */
export interface DisambiguationProduct {
  isCustom?: boolean;
  id?: string | null;
  upc?: string | null;
}

/**
 * Secondary line for products sharing a SKU: the Redo product id (always),
 * prefixed with the UPC when present. The raw source (variant) id is never shown.
 */
export function productDisambiguationText(
  product: DisambiguationProduct,
): string | null {
  if (product.isCustom || !product.id) {
    return null;
  }
  if (product.upc) {
    return `UPC ${product.upc} • ID ${product.id}`;
  }
  return `ID ${product.id}`;
}
